import React from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/9172096199"
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float-container"
      title="Chat on WhatsApp"
    >
      <div className="whatsapp-float">
        <MessageCircle size={28} />
      </div>
    </a>
  );
};

export default WhatsAppButton;
